import React, { useCallback, useState } from 'react';
import { Typography, QRCode } from 'antd';
import HeaderContent from '../HeaderContent/HeaderContent';
import ModalCommon from './ModalCommon';
import FileUploadModal from './FileUploadModal';
import { ModalConfirmPaymentProps } from 'types';
const { Text, Link } = Typography;

const ModalConfirmPayment: React.FC<ModalConfirmPaymentProps> = ({
  open,
  onClose,
  saveButtonLabel,
  headerLabel,
  headerContent,
  onSubmit,
  form,
  isLoading,
  handleUploadExcel,
}) => {
  const [openDocument, setOpenDocument] = useState<boolean>(false);

  const handleUploadComplete = useCallback(
    async (files: File[]): Promise<void> => {
      // if (files.length > 0) {
      try {
        await onSubmit?.();
        console.log('Files uploaded:', files);
        setOpenDocument(false);
      } catch (error) {
        console.error('Error confirming payment:', error);
      }
      // } else {
      //   console.warn('No files uploaded');
      // }
    },
    [onSubmit, handleUploadExcel, setOpenDocument, form],
  );
  const header = (
    <HeaderContent
      size='sm'
      key='confirm-create-product'
      label={headerLabel || ``}
      contentHeader={headerContent || ''}
    />
  );
  return (
    <ModalCommon
      open={open}
      onClose={onClose}
      onConfirm={() => {
        setOpenDocument(true);
      }}
      confirmDisabled={isLoading}
      confirmLabel={saveButtonLabel || 'Xác nhận'}
      header={header}
    >
      <div className='px-6 py-3  pt-6 flex flex-col gap-6'>
        <div className=' text-sm'>
          <Text className='text-[var(--textBlack56)]'>
            <span className='text-black'>Bước 1:</span> Tải về tệp excel sản phẩm vừa đặt <br />
            Hệ thống đã tổng hợp tất cả sản phẩm và thông tin bạn vừa chọn vào tệp{' '}
            <Link href='/BANGGIA304.xls' target='_blank' className='text-[var(--primaryColor500)] font-bold'>
              BANGGIA304.xls
            </Link>
          </Text>
        </div>
        <div>
          <Text className='text-[var(--textBlack56)]'>
            <span className='text-black'>Bước 2:</span> Gửi tệp vừa tải cho NCC qua thông tin bên dưới và xác nhận thông
            tin đơn hàng là chính xác
          </Text>
          <div className='flex justify-between py-3 px-6'>
            <div>
              <p className='text-black font-bold'>Thông tin liên hệ nhà cung cấp</p>
              <p className='pl-6 mt-3'>
                <Text className=' text-[var(--textBlack56)]'>1. Số điện thoại liên hệ</Text>
                <Link
                  className='text-[var(--primaryColor500)] font-bold'
                  href={`tel:${form.getFieldValue('supplierPhoneNumber')}`}
                >
                  {' '}
                  {form.getFieldValue('supplierPhoneNumber')}
                </Link>
              </p>
              <p className='pl-6 mt-3'>
                <Text className=' text-[var(--textBlack56)]'>2. Liên hệ theo địa chỉ</Text>
                <Link
                  className='text-[var(--primaryColor500)] font-bold'
                  href={`mailto:${form.getFieldValue('supplierEmail')}}`}
                >
                  {' '}
                  {form.getFieldValue('supplierEmail')}
                </Link>
              </p>
              <p className='pl-6 mt-3'>
                <Text className=' text-[var(--textBlack56)]'>3. Quét QR để liên hệ với nhà cung cấp qua Zalo</Text>
              </p>
            </div>
            <div>
              {form.getFieldValue('supplierPhoneNumber') && (
                <QRCode
                  size={117}
                  className='p-1'
                  value={`https://zalo.me/${form.getFieldValue('supplierPhoneNumber')}`}
                />
              )}
            </div>
          </div>
        </div>
        <div className=' text-sm'>
          <Text className='text-[var(--textBlack56)]'>
            <span className='text-black'>Bước 3:</span> Xác nhận{' '}
            {saveButtonLabel !== 'Xác nhận tạo đơn hàng' && ' và thanh toán'}
          </Text>
          <ul className='text-[var(--textBlack56)] mt-1'>
            <li className='list-disc ml-6'>
              Sau khi xác nhận thông tin với NCC hoàn toàn đúng, giá sản phẩm chính xác. Vui lòng thanh toán toàn bộ giá
              tiền và cập nhật chứng từ thanh toán{' '}
              <span
                className='text-[var(--primaryColor500)] font-bold cursor-pointer'
                onClick={() => setOpenDocument(true)}
              >
                tại đây
              </span>
            </li>
            <li className='list-disc ml-6 mt-1'>
              Nếu sai thông tin, bạn cần trở về để chỉnh sửa thông tin cho chính xác
            </li>
          </ul>
        </div>
      </div>
      <FileUploadModal
        isOpen={openDocument}
        onClose={() => setOpenDocument(false)}
        onUpload={handleUploadExcel}
        onComplete={handleUploadComplete}
        title={'TẢI LÊN CHỨNG TỪ THANH TOÁN'}
        subtitle={'Vui lòng tải lên thông tin hình ảnh và xác nhận với kế toán'}
        acceptedFileTypes={'.xlsx,.xls,.xlsm,.xlm,.png,.jpg,.jpeg,.webp,.gif,.bmp'}
        fileTypesHelpText={'Hỗ trợ các tệp tin excel, png, jpg, gif, bmp, ...'}
        multiple={false}
        maxFileSize={5 * 1024 * 1024}
        typeModal='upload'
        positionButton='center'
        confirmText='Xác nhận thanh toán'
      />
    </ModalCommon>
  );
};

export default ModalConfirmPayment;
